<template>
  <section :class="`${sectionName}`">
    <div :class="`${sectionName}__container`">
      <div :class="`${sectionName}__head`">
        <h2 :class="`${sectionName}__title`">
          {{ title }}
        </h2>
        <a
          v-if="needLink && !needToMoveLinkToBottom"
          :href="linkUrl"
          class="text-link--sub tl-link-chevron-forward--right"
          :data-gtm-page="linkDataGtmPage"
          :data-gtm-click="linkDataGtmClick"
          @click="onClickLink"
        >
          {{ linkString }}
        </a>
      </div>
      <slot />
      <div
        v-if="needLink && needToMoveLinkToBottom"
        :class="`${sectionName}__bottom`"
      >
        <a
          :href="linkUrl"
          class="text-link--sub tl-link-chevron-forward--right"
          :data-gtm-page="linkDataGtmPage"
          :data-gtm-click="linkDataGtmClick"
          @click="onClickLink"
        >
          {{ linkString }}
        </a>
      </div>
    </div>
  </section>
</template>
<script>
export default {
  props: {
    sectionName: {
      type: String,
      required: true
    },
    title: {
      type: String,
      required: true
    },
    linkString: {
      type: String,
      required: false,
      default: ''
    },
    linkUrl: {
      type: String,
      required: false,
      default: ''
    },
    needLink: {
      type: Boolean,
      required: false,
      default: true
    },
    needToMoveLinkToBottom: {
      type: Boolean,
      required: false,
      default: false
    },
    linkDataGtmPage: {
      type: String,
      required: false,
      default: null
    },
    linkDataGtmClick: {
      type: String,
      required: false,
      default: null
    }
  },
  methods: {
    onClickLink() {
      this.$emit('click-link')
    }
  }
}
</script>
